import _ from "lodash";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";
import {
  dbDateFormatterForGrid,
  dbTimeFormatterForGrid,
  gridCentsPerShareFormatter,
  myValueFormatter,
  myValueFormatter_quantity,
  rateFormatter,
} from "./commonFunctions";
import { LocateStatus, TradeStatus } from "./constants";
import editIcon from '../assets/images/editIcon.png';

export const locateColdDefs = [
  {
    headerName: "",
    field: "isSelect",
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    headerCheckboxSelection: true,
    showDisabledCheckboxes: true,
    checkboxSelection: true,
    editable: false,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    pinned: "left",
    lockPinned: true,
    cellClass: "lock-pinned",

    minWidth: 40,
    maxWidth: 50,
    suppressSizeToFit: false,
  },
  {
    filter: "agSetColumnFilter",
    headerName: "Batch Id",
    field: "batch",
    sortable: true,
    editable: false,
    minWidth: 85,
    hide:true,
    maxWidth: 110,
    cellDataType: "text",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    filter: "agSetColumnFilter",
    headerName: "Locate Id",
    field: "locate_id",
    sortable: true,
    editable: false,
    minWidth: 90,
    maxWidth: 130,
    cellDataType: "text",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Account Id",
    field: "account_id",
    floatingFilter: false,
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      // borderRight: "0.5px solid #E1E1E1",
      alignItems: "center",
    },
    minWidth: 100,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
  },
  {
    headerName: "Client",
    field: "cpty",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      // borderRight: "0.5px solid #E1E1E1",
      alignItems: "center",
    },
    minWidth: 85,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
  },
  {
    headerName: "Trading Account",
    field: "trading_account_id",
    floatingFilter: false,
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      // borderRight: "0.5px solid #E1E1E1",
      alignItems: "center",
    },
    minWidth: 140,
    maxWidth: 150,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
  },
  {
    filter: "agSetColumnFilter",
    headerName: "User",
    field: "username",
    sortable: true,
    editable: false,
    minWidth: 90,
    maxWidth: 110,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    filter: "agSetColumnFilter",
    headerName: "Source",
    field: "locate_src",
    sortable: true,
    editable: false,
    minWidth: 80,
    maxWidth: 100,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      // borderRight: "0.5px solid #E1E1E1",
      alignItems: "center",
    },
    minWidth: 80,
    maxWidth: 100,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
    cellRenderer: TickerHyperLinkComponent,
  },
  {
    headerName: "Security Name",
    field: "secName",
    minWidth: 100,
    maxWidth: 250,
    hide: true,
    filter: "agSetColumnFilter",
    sortable: true,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 80,
    maxWidth: 100,
    suppressSizeToFit: false,
    sortable: true,
  },
  {
    headerName: "Req Qty",
    field: "request_quantity",
    type: "rightAligned",
    cellDataType:'text',
    floatingFilter: false,
    editable: function (params: any) {
      return (
        params?.node?.data?.status === LocateStatus.New ||
        params?.node?.data?.status === LocateStatus.Error
      );
    },
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.isReqQuantityChanged &&
        !params?.node?.data?.isReqQuantityValid
      ) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
          backgroundColor: TradeStatus.error,
        };
      } else if (params?.node?.data?.isReqQuantityChanged) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
          backgroundColor: TradeStatus.sent,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    headerComponentParams: {
      template: `
      <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        <img class="ms-1" height="8px" width="8px" src="${editIcon}" /> 
        <span ref="eText" class="ag-header-cell-text"></span>
        <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
    </div>
</div>`
    },
    minWidth: 95,
    maxWidth: 100,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },
  {
    headerName: "Appr Qty",
    field: "approved_quantity",
    type: "rightAligned",
    floatingFilter: false,
    cellDataType:'text',
    editable: function (params: any) {
      return (
        params?.node?.data?.status === LocateStatus.Pending || params?.node?.data?.status === LocateStatus.Rejected
      );
    },
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.isApprovedQuantityChanged &&
        !params?.node?.data?.isApprovedQuantityValid
      ) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
          backgroundColor: TradeStatus.error,
        };
      } else if (params?.node?.data?.isApprovedQuantityChanged) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
          backgroundColor: TradeStatus.sent,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    headerComponentParams: {
      template: `
      <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        <img class="ms-1" height="8px" width="8px" src="${editIcon}" /> 
        <span ref="eText" class="ag-header-cell-text"></span>
        <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
    </div>
</div>`
    },
    minWidth: 100,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
    enableCellChangeFlash:true,
  },
  {
    headerName: "Res Qty",
    field: "response_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    hide: true,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 120,
    maxWidth: 150,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },
  {
    headerName: "Status",
    field: "status",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },

    cellStyle: function (params: any) {
      if (
        params?.node?.data?.status === LocateStatus.Rejected || params?.node?.data?.status === LocateStatus.Error
      ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          color: "#FF0000",
        };
      } else if ( params?.node?.data?.status === LocateStatus.Topup || params?.node?.data?.status === LocateStatus.Approved || params?.node?.data?.status === LocateStatus.Available) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
         color: "#008000", 
          
        };
      }else if ( params?.node?.data?.status === LocateStatus.Override || params?.node?.data?.status === LocateStatus.UnAvailable 
        ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          color: "#e84679f4",
        };
      } else if (params?.node?.data?.status === LocateStatus.Partial) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          color: "#FFA500",
        };
      }else if (params?.node?.data?.status === LocateStatus.Pending) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          color: "rgb(226 135 11)",
        };
      }
       else {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
    minWidth: 90,
    maxWidth: 140,
    // cellRenderer: StatusRenderer,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
    enableCellChangeFlash:true,
  },

  {
    headerName: "Req CPS",
    field: "centpershare",
    floatingFilter: false,
    type: "rightAligned",
    editable: function (params: any) {
      return false;
    },
    enableCellChangeFlash:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 90,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    valueFormatter: gridCentsPerShareFormatter,
    sortable: true,
  },
  {
    headerName: "Appr CPS",
    field: "centpershare_appr",
    floatingFilter: false,
    type: "rightAligned",
    editable: function (params: any) {
      return (
        params?.node?.data?.status === LocateStatus.Pending ||
        params?.node?.data?.status === LocateStatus.Rejected
      );
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
   
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.isCentPerShareChanged &&
        !params?.node?.data?.isCentsPerShareValid
      ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
          backgroundColor: TradeStatus.error,
        };
      } else if (params?.node?.data?.isCentPerShareChanged) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
          backgroundColor: TradeStatus.sent,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 105,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    valueFormatter: gridCentsPerShareFormatter,
    // cellRenderer: LocateCellEditRenderer,
    headerComponentParams: {
      template: `
      <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        <img class="ms-1" height="8px" width="8px" src="${editIcon}" /> 
        <span ref="eText" class="ag-header-cell-text"></span>
        <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
    </div>
</div>`
    },
    sortable: true,
    enableCellChangeFlash:true,
  },
  {
    headerName: "Fee",
    minWidth: 80,
    hide: true,
    field: "fee",
    type: "rightAligned",
    valueFormatter: myValueFormatter,
    filter: "agMultiColumnFilter",
    sortable: true,
    editable: function (params: any) {
      return (
        params?.node?.data?.status === LocateStatus.Pending ||
        params?.node?.data?.status === LocateStatus.Rejected
      );
    },
    // cellRenderer: LocateCellEditRenderer,
    headerComponentParams: {
      template: `
      <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        <img class="ms-1" height="8px" width="8px" src="${editIcon}" /> 
        <span ref="eText" class="ag-header-cell-text"></span>
        <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
    </div>
</div>`
    },
    cellStyle: function (params: any) {
      if (params?.node?.data?.isFeeChanged) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
          backgroundColor: TradeStatus.sent,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    enableCellChangeFlash:true,
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Req Rebate",
    field: "rebate",
    sortable: true,
    cellDataType:'text',
    type: "rightAligned",
    editable: function (params: any) {
      return false;
    },
    minWidth: 120,
    maxWidth: 140,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    enableCellChangeFlash:true,
    valueFormatter: rateFormatter
  },

  {
    filter: "agMultiColumnFilter",
    headerName: "Appr Rebate",
    field: "rate_appr",
    sortable: true,
    type: "rightAligned",
    cellDataType: "text",
    editable: function (params: any) {
      return (
        params?.node?.data?.status === LocateStatus.Pending ||
        params?.node?.data?.status === LocateStatus.Rejected
      );
    },
    // cellRenderer: LocateCellEditRenderer,
    headerComponentParams: {
      template: `
      <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        <img class="ms-1" height="8px" width="8px" src="${editIcon}" /> 
        <span ref="eText" class="ag-header-cell-text"></span>
        <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
    </div>
</div>`
    },
    minWidth: 115,
    maxWidth: 130,
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.isRebateChanged &&
        !params?.node?.data?.isRebateValid
      ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
          backgroundColor: TradeStatus.error,
        };
      } else if (params?.node?.data?.isRebateChanged) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
          backgroundColor: TradeStatus.sent,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    enableCellChangeFlash:true,
    valueFormatter: rateFormatter
  },
 
  {
   minWidth: 150,
    maxWidth: 200,
    filter: "agTextColumnFilter",
    headerComponentParams: {
      template: `
      <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        <img class="me-1" height="8px" width="8px" src="${editIcon}" /> 
        <span ref="eText" class="ag-header-cell-text"></span>
        <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
    </div>
</div>`
    },
    field: "comments",
    sortable: true,
    editable: function (params: any) {
      return (
        params?.node?.data?.status === LocateStatus.Topup || params?.node?.data?.status === LocateStatus.Approved
      );
    },
    enableCellChangeFlash:true,
    // cellRenderer: LocateCellEditRenderer,
    cellStyle: function (params: any) {
      if (params?.node?.data?.isCommentsChanged) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          backgroundColor: TradeStatus.sent,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
  },

  {
    headerName: "Used Qty",
    field: "filled_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 100,
    maxWidth: 130,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },
  {
    headerName: "PNL",
    field: "locate_pnl",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 100,
    maxWidth: 140,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Req Time Stamp",
    field: "updatetime",
    sortable: true,
    editable: false,
    minWidth: 140,
    maxWidth: 200,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Res Time Stamp",
    field: "updatetime",
    sortable: true,
    editable: false,
    minWidth: 140,
    maxWidth: 200,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
    {
    headerName: "Error Code",
    minWidth: 130,
    editable: false,
    field: "error_status",
    pinned:'right',
    enableCellChangeFlash: false,
    cellStyle: function () {
      return {
        display: "flex",
        //  borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  // {
  //   headerName: "Action",
  //   minWidth: 90,
  //   maxWidth: 160,
  //   editable: false,
  //   colId: "action",
  //   pinned:'right',
  //   enableCellChangeFlash: false,
  //   cellStyle: function () {
  //     return {
  //       display: "flex",
  //       // borderRight: "0.5px solid #E1E1E1",
  //       alignItems: "center",
  //     };
  //   },
  // },
];
export const locateClientColdDefs = [
  {
    headerName: "",
    field: "isSelect",
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    headerCheckboxSelection: true,
    showDisabledCheckboxes: true,
    checkboxSelection: true,
    editable: false,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      // borderRight: "0.5px solid #E1E1E1",
    },
    pinned: "left",
    lockPinned: true,
    cellClass: "lock-pinned",

    minWidth: 40,
    maxWidth: 50,
    suppressSizeToFit: false,
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Locate Id",
    field: "locate_id",
    sortable: true,
    editable: false,
    minWidth: 80,
    maxWidth: 100,
    cellDataType: "text",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Account",
    field: "account_id",
    floatingFilter: false,
    editable: false,
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      // borderRight: "0.5px solid #E1E1E1",
      alignItems: "center",
    },
    minWidth: 80,
    maxWidth: 100,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },
  {
    headerName: "Client",
    field: "cpty",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
    },
    minWidth: 85,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "User",
    field: "username",
    sortable: true,
    editable: false,
    minWidth: 90,
    maxWidth: 110,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Trading Account",
    field: "trading_account_id",
    floatingFilter: false,
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      // borderRight: "0.5px solid #E1E1E1",
      alignItems: "center",
    },
    minWidth: 85,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Source",
    field: "locate_src",
    sortable: true,
    editable: false,
    minWidth: 80,
    maxWidth: 100,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      // borderRight: "0.5px solid #E1E1E1",
      alignItems: "center",
    },
    minWidth: 80,
    maxWidth: 100,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
    cellRenderer: TickerHyperLinkComponent,
  },
  {
    headerName: "Security Name",
    field: "secName",
    minWidth: 150,
    maxWidth: 250,
    hide: true,
    filter: "agSetColumnFilter",
    sortable: true,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    editable: false,
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 80,
    maxWidth: 100,
    suppressSizeToFit: false,
    sortable: true,
  },
  {
    headerName: "Req Qty",
    field: "request_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 90,
    maxWidth: 100,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },
  {
    headerName: "Appr Qty",
    field: "approved_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 90,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },
  {
    headerName: "Res Qty",
    field: "response_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    hide: true,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 170,
    maxWidth: 190,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },

  {
    headerName: "Status",
    field: "status",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
  
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.status === LocateStatus.Rejected
      ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          color: "#FF0000",
        };
      } else if ( params?.node?.data?.status === LocateStatus.Topup || params?.node?.data?.status === LocateStatus.Approved || params?.node?.data?.status === LocateStatus.Available) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
         color: "#008000", 
          
        };
      }else if ( params?.node?.data?.status === LocateStatus.Override || params?.node?.data?.status === LocateStatus.UnAvailable 
        ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          color: "#e84679f4"
        };
      } else if (params?.node?.data?.status === LocateStatus.Partial) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          color: "#FFA500",
        };
      }else if (params?.node?.data?.status === LocateStatus.Pending) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          color: "rgb(226 135 11)",
        };
      }
       else {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
    minWidth: 120,
    maxWidth: 140,
    // cellRenderer: StatusRenderer,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },
  {
    headerName: "Req CPS",
    field: "centpershare",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      // borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 90,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    valueFormatter: gridCentsPerShareFormatter,
    sortable: true,
  },
  {
    headerName: "Appr CPS",
    field: "centpershare_appr",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      // borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 90,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    valueFormatter: gridCentsPerShareFormatter,
    sortable: true,
  },
  {
    headerName: "Fee",
    minWidth: 80,
    field: "fee",
    hide: true,
    type: "rightAligned",
    valueFormatter: myValueFormatter,
    filter: "agMultiColumnFilter",
    sortable: true,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Req Rebate",
    field: "rebate",
    sortable: true,
    editable: false,
    minWidth: 80,
    maxWidth: 150,
    cellDataType: "text",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
   valueFormatter: rateFormatter
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Appr Rebate",
    field: "rate_appr",
    sortable: true,
    editable: false,
    minWidth: 80,
    maxWidth: 150,
    cellDataType: "text",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
 valueFormatter: rateFormatter
  },
  {
    field: "comments",
    headerName:'Comments',
    minWidth: 250,
    maxWidth: 350,
    filter: "agMultiColumnFilter",
    sortable: true,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
   
  },
  {
    headerName: "Used Qty",
    field: "filled_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 100,
    maxWidth: 130,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },
   
  {
    headerName: "Total Cost",
    field: "locate_pnl",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 90,
    maxWidth: 110,
    suppressSizeToFit: false,
    filter: "agMultiColumnFilter",
    sortable: true,
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Requested Time Stamp",
    field: "updatetime",
    sortable: true,
    editable: false,
    minWidth: 190,
    maxWidth: 250,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
    // valueFormatter: dbTimeFormatterForGrid,
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Response Time Stamp",
    field: "updatetime",
    sortable: true,
    editable: false,
    minWidth: 190,
    maxWidth: 250,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
    // valueFormatter: dbTimeFormatterForGrid,
  },
];

export const preBorrowColdDefs = [
  {
    headerName: "Id",
    field: "preborrows_id",
    minWidth: 120,
    maxWidth: 150,
    filter: "agSetColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellDataType: "text",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
  {
    headerName: "Client",
    field: "cpty",
    minWidth: 90,
    maxWidth: 150,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Trading Account",
    field: "trading_account_id",
    floatingFilter: false,
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      // borderRight: "0.5px solid #E1E1E1",
      alignItems: "center",
    },
    minWidth: 140,
    maxWidth: 150,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    sortable: true,
  },
  {
    headerName: "Ticker",
    field: "sec_id",
    minWidth: 60,
    maxWidth: 80,
    filter: "agSetColumnFilter",
    sortable: true,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
    cellRenderer: TickerHyperLinkComponent,
  },
  {
    headerName: "Security Name",
    field: "sec_name",
    minWidth: 100,
    maxWidth: 250,
    filter: "agSetColumnFilter",
    sortable: true,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
  },
  {
    headerName: "Quantity",
    field: "total_request_quantity",
    minWidth: 150,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    valueFormatter: myValueFormatter_quantity,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },

  {
    headerName: "Rate",
    field: "rate",
    minWidth: 150,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    valueFormatter: rateFormatter
  },
  {
    headerName: "Value",
    field: "value",
    valueFormatter: myValueFormatter,
    minWidth: 150,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
  {
    headerName: "Accrual",
    field: "accrual",
    minWidth: 150,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    valueFormatter: myValueFormatter,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
  {
    field: "status",
    minWidth: 130,
    filter: "agSetColumnFilter",
    // cellRenderer: StatusRenderer,
    sortable: true,
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.status === LocateStatus.Rejected
      ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          backgroundColor: TradeStatus.error,
        };
      } else if ( params?.node?.data?.status === LocateStatus.Topup ||  params?.node?.data?.status === LocateStatus.Approved|| params?.node?.data?.status === LocateStatus.Available) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          backgroundColor: TradeStatus.booked,
        };
      }else if ( params?.node?.data?.status === LocateStatus.Override || params?.node?.data?.status === LocateStatus.Pending || params?.node?.data?.status === LocateStatus.UnAvailable 
        ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          backgroundColor: TradeStatus.sent,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
  },

  {
    headerName: "Last Updated Time",
    field: "updatedtime",
    minWidth: 150,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
    valueFormatter: dbDateFormatterForGrid,
  },
];

export const mostLocatedColDefs = [
  {
    headerName: "Symbol",
    field: "secid",
    minWidth: 60,
    filter: "agSetColumnFilter",
    sortable: true,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 75,
    maxWidth: 170,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
    sortable: true,
  },
  {
    headerName: "Name",
    field: "name",
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 220,
    maxWidth: 250,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
    filter: "agSetColumnFilter",
    editable: false,
  },

  {
    headerName: "Total Req Count",
    field: "total_request_count",
    minWidth: 80,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellDataType: "text",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    valueFormatter: myValueFormatter_quantity,
  },
  {
    headerName: "Total Req Qty",
    field: "total_quantity",
    valueFormatter: myValueFormatter_quantity,
    minWidth: 80,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
  {
    headerName: "Total Resp Qty",
    field: "total_response_quantity",
    valueFormatter: myValueFormatter_quantity,
    minWidth: 80,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
  {
    headerName: "Total Filled Count",
    field: "total_fill_count",
    valueFormatter: myValueFormatter_quantity,
    minWidth: 80,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
  {
    headerName: "Total Filled Qty",
    field: "totalFillQty",
    valueFormatter: myValueFormatter_quantity,
    minWidth: 80,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },

  {
    headerName: "Min Rate",
    field: "minrate",
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 120,
    sortable: true,
    valueFormatter: rateFormatter
  },
  {
    headerName: "Max Rate",
    field: "maxrate",
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 120,
    sortable: true,
    valueFormatter: rateFormatter
  },
  {
    headerName: "Avg Rate",
    field: "avgrate",
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 120,
    sortable: true,
    valueFormatter: rateFormatter
  },
  {
    headerName: "PNL",
    field: "pnl",
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    editable: false,
    hide: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 120,
    sortable: true,
    valueFormatter: myValueFormatter,
  },
  {
    headerName: "Last updated time",
    field: "updatedTime",
    minWidth: 150,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
    valueFormatter: dbDateFormatterForGrid,
  },
];

export const clientMostLocatedColDefs = [
  {
    headerName: "Symbol",
    field: "secid",
    minWidth: 60,
    filter: "agSetColumnFilter",
    sortable: true,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 75,
    maxWidth: 170,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
    sortable: true,
  },
  {
    headerName: "Name",
    field: "name",
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 220,
    maxWidth: 250,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
    filter: "agSetColumnFilter",
    editable: false,
  },

  {
    headerName: "Total Req Count",
    field: "total_request_count",
    minWidth: 80,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellDataType: "text",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    valueFormatter: myValueFormatter_quantity,
  },
  
  {
    headerName: "Total Req Qty",
    field: "total_quantity",
    valueFormatter: myValueFormatter_quantity,
    minWidth: 80,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
  {
    headerName: "Total Resp Qty",
    field: "total_response_quantity",
    valueFormatter: myValueFormatter_quantity,
    minWidth: 80,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
    {
    headerName: "Total Filled Count",
    field: "total_fill_count",
    valueFormatter: myValueFormatter_quantity,
    minWidth: 80,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
  {
    headerName: "Total Filled Qty",
    field: "totalFillQty",
    valueFormatter: myValueFormatter_quantity,
    minWidth: 80,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },

  {
    headerName: "Min Rate",
    field: "minrate",
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 120,
    sortable: true,
    valueFormatter: rateFormatter
  },
  {
    headerName: "Max Rate",
    field: "maxrate",
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 120,
    sortable: true,
    valueFormatter: rateFormatter
  },
  {
    headerName: "Avg Rate",
    field: "avgrate",
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 120,
    sortable: true,
    valueFormatter: rateFormatter
  },

  {
    headerName: "Last updated time",
    field: "updatedTime",
    minWidth: 150,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
    valueFormatter: dbDateFormatterForGrid,
  },
];

export const locatePNLGroupByColDef = [
  {
    headerName: "Client",
    field: "client",
    minWidth: 80,
    maxWidth: 200,
    hide: false,
    editable: false,
    rowGroup: true,
    filter: "agMultiColumnFilter",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return "(" + _.uniq(params.values).length + ")";
      } else {
        return "(0)";
      }
    },
    enableRowGroup: true,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      // borderRight: "0.5px solid #E1E1E1",
    },
    sortable: true,
  },
  {
    headerName: "Date",
    field: "filled",
    minWidth: 80,
    maxWidth: 350,
    hide: false,
    editable: false,
    cellDataType: "text",
    filter: "agSetColumnFilter",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return "(" + _.uniq(params.values)?.length + ")";
      } else {
        return "(0)";
      }
    },
    enableRowGroup: true,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      // borderRight: "0.5px solid #E1E1E1",
    },
    sortable: true,
    rowGroup: true,
    //valueFormatter:onlyDateFormatterForGrid
  },
  {
    headerName: "Ticker",
    field: "sec_id",
    minWidth: 70,
    maxWidth: 200,
    enableRowGroup: true,
    chartDataType: "category",
    editable: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return "(" + _.uniq(params.values).length + ")";
      } else {
        return "(0)";
      }
    },
    filter: "agMultiColumnFilter",
    cellStyle: {
      display: "flex",
      alignItems: "center",
      // borderRight: "0.5px solid #E1E1E1",
    },
    sortable: true,
  },
  {
    headerName: "Locate Count",
    field: "locate_count",
    minWidth: 70,
    maxWidth: 200,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return _.sum(params.values);
      } else {
        return "(0)";
      }
    },
    editable: false,
    filter: "agMultiColumnFilter",
    chartDataType: "category",
    type: "rightAligned",
    cellStyle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      // borderRight: "0.5px solid #E1E1E1",
    },
    valueFormatter: myValueFormatter_quantity,
    sortable: true,
  },

  {
    headerName: "PNL",
    field: "pnl",
    minWidth: 70,
    maxWidth: 200,
    chartDataType: "category",
    editable: false,
    filter: "agMultiColumnFilter",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return parseFloat(
          parseFloat(_.sum(params.values)?.toString())?.toFixed(3)
        );
      } else {
        return "0";
      }
    },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      // borderRight: "0.5px solid #E1E1E1",
    },
    valueFormatter: myValueFormatter,
    sortable: true,
  },

  {
    headerName: "Updated Date",
    field: "updatedtime",
    minWidth: 80,
    maxWidth: 200,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    editable: false,
    filter: "agSetColumnFilter",
    chartDataType: "category",
    cellStyle: {
      display: "flex",
      alignItems: "center",
      // borderRight: "0.5px solid #E1E1E1",
    },
    sortable: true,
    valueFormatter: dbDateFormatterForGrid,
  },
];

export const locateTabMostLocatedColDefs = [
  {
    headerName: "Symbol",
    field: "secid",
    minWidth: 83,
    filter: "agSetColumnFilter",
    sortable: true,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
    cellRenderer: TickerHyperLinkComponent
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    editable: false,
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 75,
    maxWidth: 170,
    suppressSizeToFit: false,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
    sortable: true,
  },
  {
    headerName: "Name",
    field: "name",
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 140,
    maxWidth: 190,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
    filter: "agSetColumnFilter",
    editable: false,
  },
  // {
  //   headerName: "Client Count",
  //   field: "totalClientCount",
  //   minWidth: 80,
  //   filter: "agSetColumnFilter",
  //   sortable: true,
  //   type: "rightAligned",
  //   cellDataType: "text",
  //   cellStyle: function () {
  //     return {
  //       display: "flex",
  //       alignItems: "center",
  //       borderRight: "0.5px solid #E1E1E1",
  //       justifyContent: "flex-end",
  //     };
  //   },
  //   valueFormatter: myValueFormatter_quantity,
  // },
  {
    headerName: "Req Count",
    field: "total_request_count",
    minWidth: 92,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellDataType: "text",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    valueFormatter: myValueFormatter_quantity,
  },
  {
    headerName: "Req Qty",
    field: "total_quantity",
    valueFormatter: myValueFormatter_quantity,
    minWidth: 83,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
  {
    headerName: "Resp Qty",
    field: "total_response_quantity",
    valueFormatter: myValueFormatter_quantity,
    minWidth: 95,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
   {
    headerName: "Total Filled Qty",
    field: "totalFillQty",
    valueFormatter: myValueFormatter_quantity,
    minWidth: 122,
    filter: "agMultiColumnFilter",
    sortable: true,
    type: "rightAligned",
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
  },
  {
    headerName: "Min Rate",
    field: "minrate",
    hide: true,
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 120,
    sortable: true,
    valueFormatter: rateFormatter
  },
  {
    headerName: "Max Rate",
    field: "maxrate",
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 120,
    sortable: true,
    valueFormatter: rateFormatter
  },
  {
    headerName: "Avg Rate",
    field: "avgrate",
    hide: true,
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 120,
    sortable: true,
    valueFormatter: rateFormatter
  },
  {
    headerName: "PNL",
    field: "pnl",
    floatingFilter: false,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 120,
    sortable: true,
    valueFormatter: myValueFormatter,
  },
  {
    headerName: "Last updated time",
    field: "updatedTime",
    minWidth: 150,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
    valueFormatter: dbTimeFormatterForGrid,
  },
];

export const enquiryColdDefs = [
  {
    field: "inquiry_id",
    headerName: "Inquiry Id",
    minWidth: 95,
    filter: "agMultiColumnFilter",
    cellDataType:'text',
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Account Id",
    field: "account_id",
    minWidth: 100,
    maxWidth: 120,
    hide:true,
    filter: "agMultiColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    field: "cpty",
    headerName: "Client",
    minWidth: 80,
    hide:true,
    maxWidth: 100,
    filter: "agMultiColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Trading Account",
    field: "trading_account_id",
    minWidth: 150,
    maxWidth: 170,
    hide:true,
    filter: "agMultiColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "User",
    field: "username",
    minWidth: 130,
    filter: "agMultiColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Source",
    field: "locate_src",
    sortable: true,
    editable: false,
    minWidth: 85,
    maxWidth: 150,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    field: "ticker",
    minWidth: 80,
    maxWidth: 110,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Security Name",
    field: "secName",
    minWidth: 160,
    maxWidth: 250,
    hide: true,
    filter: "agSetColumnFilter",
    sortable: true,
    cellStyle: function () {
      return {
        display: "flex",
        alignItems: "center",
        // borderRight: "0.5px solid #E1E1E1",
      };
    },
  },
  {
    field: "cusip",
    minWidth: 130,
    hide: true,
    filter: "agSetColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Req qty",
    field: "request_quantity",
    minWidth: 120,
    type: "rightAligned",
    filter: "agMultiColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
        justifyContent: "right",
      };
    },
  },
  {
    headerName: "Appr qty",
    field: "approved_quantity",
    type: "rightAligned",
    minWidth: 120,
    filter: "agMultiColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
        justifyContent: "right",
      };
    },
  },
  {
    field: "status",
    headerName:'Status',
    filter: "agSetColumnFilter",
    minWidth: 90,
    // cellRenderer: StatusRenderer,
    cellStyle: function (params: any) {
      if (
        params?.node?.data?.status === LocateStatus.Rejected
      ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          // backgroundColor: TradeStatus.error,
          color: "#FF0000",
        };
      } else if (params?.node?.data?.status === LocateStatus.Topup || params?.node?.data?.status === LocateStatus.Approved || params?.node?.data?.status === LocateStatus.Available) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          // backgroundColor: TradeStatus.booked,
          color: "#008000",
        };
      }else if ( params?.node?.data?.status === LocateStatus.Override || params?.node?.data?.status === LocateStatus.Pending || params?.node?.data?.status === LocateStatus.UnAvailable 
        ) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          // backgroundColor: TradeStatus.sent,
          color: "#e84679f4",
        };
      } else if ( params?.node?.data?.status === LocateStatus.Partial) {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
          // backgroundColor: TradeStatus.sent,
          color: "#FFA000",
        };
      }
       else {
        return {
          display: "flex",
          alignItems: "center",
          // borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
  },
  {
    headerName: "Req CPS",
    field: "centpershare",
    minWidth: 90,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    cellDataType:'text',
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
        justifyContent: "right",
      };
    },
  },
  {
    headerName: "Appr CPS",
    field: "centpershare_appr",
    minWidth: 90,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    cellDataType:'text',
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
        justifyContent: "right",
      };
    },
  },
  {
    field: "fee",
    minWidth: 130,
    filter: "agMultiColumnFilter",
    hide: true,
    type: "rightAligned",
    valueFormatter: myValueFormatter_quantity,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
        justifyContent: "right",
      };
    },
  },
  {
    headerName: "Req Rebate",
    field: "rebate",
    minWidth: 100,
    filter: "agMultiColumnFilter",
    type: "rightAligned",
    cellDataType:'text',
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
        justifyContent: "right",
      };
    },
    valueFormatter: rateFormatter
  },
  {
    filter: "agMultiColumnFilter",
    headerName: "Appr Rebate",
    field: "rate_appr",
    sortable: true,
    type: "rightAligned",
    cellDataType: "text",
    editable: function (params: any) {
      return (
        params?.node?.data?.status === LocateStatus.Pending ||
        params?.node?.data?.status === LocateStatus.Rejected
      );
    },
    // cellRenderer: LocateCellEditRenderer,
  
    minWidth: 115,
    maxWidth: 130,
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
        justifyContent: "right",
      };
    },
    enableCellChangeFlash:true,
    valueFormatter: rateFormatter
  },
  
  {
    field: "comments",
    minWidth: 130,
    filter: "agMultiColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
  {
    headerName: "Requested time stamp",
    field: "requested_time",
    minWidth: 180,
    filter: "agMultiColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
    // valueFormatter: dbTimeFormatterForGrid,
  },
  {
    headerName: "Response time stamp",
    field: "response_time",
    minWidth: 180,
    filter: "agMultiColumnFilter",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
    // valueFormatter: dbTimeFormatterForGrid,
  },
  {
    headerName: "Action",
    minWidth: 220,
    maxWidth: 320,
    editable: false,
    colId: "action",
    cellStyle: function () {
      return {
        display: "flex",
        // borderRight: "0.5px solid #E1E1E1",
        alignItems: "center",
      };
    },
  },
];
